import React from 'react';

import { styles as sharedStyles } from '@swf/account';
import StarsInfo from '@swf/components/StarsInfo/StarsInfo';
import Translation from '@swf/components/Translation/Translation';

import View from '../View/View';

import {
  TXTCLI_Receive_Tournament_Money_throu_ELL,
  TXTCLI_Tournament_Money,
  TXTCLI_Unregistering_from_a_tournamen_ELL,
  TXTCLI_Use_Tournament_Money_to_regist_ELL,
  TXTCLI_Winning_more_than_one_satellit_ELL,
  TXTWCL_From_a_Chest_or_as_part_of_spe_ELL,
  TXTWCL_Please_login_to_our_downloadab_ELL_1
} from './TournamentMoney.messages.json';
import Balances from './components/Balances/Balances';

export const TournamentMoneyBody: React.FC = () => (
  <>
    <Translation tagName="p" {...TXTCLI_Use_Tournament_Money_to_regist_ELL} />
    <Balances />
    <StarsInfo className={sharedStyles.message}>
      <Translation {...TXTWCL_Please_login_to_our_downloadab_ELL_1} />
    </StarsInfo>
    <Translation tagName="p" {...TXTCLI_Receive_Tournament_Money_throu_ELL} />
    <ul className={sharedStyles.list}>
      <Translation tagName="li" {...TXTWCL_From_a_Chest_or_as_part_of_spe_ELL} />
      <Translation tagName="li" {...TXTCLI_Winning_more_than_one_satellit_ELL} />
      <Translation tagName="li" {...TXTCLI_Unregistering_from_a_tournamen_ELL} />
    </ul>
  </>
);

const TournamentMoney: React.FC = () => (
  <View title={<Translation {...TXTCLI_Tournament_Money} />}>
    <TournamentMoneyBody />
  </View>
);

export default TournamentMoney;
